<template>
  <v-dialog v-model="dialog" width="350px">
    <v-card>
      <v-card-title class="grey lighten-2">SELECCIONE UNA OPCION</v-card-title>
      <v-card-text>
        <v-radio-group v-model="selectOption">
          <v-radio label="Invitación" value="invitation" class="mt-3"></v-radio>
          <v-radio
            label="Error de Usuario"
            value="userError"
            class="mt-3"
          ></v-radio>
          <v-radio
            v-if="isMenuGroupOrder"
            label="Falta de Stock"
            value="outOfStock"
            class="mt-3"
          ></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn text @click="dialog = false">Cerrar</v-btn>
        <v-btn outlined :disabled="selectOption === null" @click="onDone"
          >Hecho</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "select-option-dialog",
  data() {
    return {
      selectOption: null,
      item: null,
      dialog: false
    };
  },
  computed: {
    isMenuGroupOrder() {
      return this.item && this.item.isMenuGroupProduct
        ? !this.item.isMenuGroupProduct
        : true;
    }
  },
  watch: {
    dialog() {
      if (this.dialog === false) {
        this.selectOption = null;
      }
    }
  },
  methods: {
    open(item) {
      this.item = item;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.selectOption = null;
    },
    onDone() {
      let data = {
        item: this.item,
        selectOption: this.selectOption
      };
      this.$emit("removeProduct", data);

      setTimeout(() => {
        this.dialog = false;
      }, 200);
    }
  }
};
</script>

<style></style>
